import $ from 'jquery';
import BasketService from '../service/BasketService';

$('.catalog-detail-purchase__button').click(function () {
    if ($(this).hasClass('catalog-detail-purchase__button--active')) {
        window.location = '/basket';
        return;
    }

    $(this).addClass('catalog-detail-purchase__button--active')
        .find('span')
        .text('In basket');

    BasketService.add(
        $(this).attr('data-product-id'),
        $('.catalog-detail-quantity__value').val()
    ).then((response) => {
        $('.header-cart__quantity').text(response.count).removeClass('hidden');
        $('.header-cart__quantity').addClass('header-cart__quantity--added');
        setTimeout(() => {
            $('.header-cart__quantity').removeClass('header-cart__quantity--added');
        }, 300);
    });
});
